(function () {
    'use strict';

    if (typeof window === 'undefined') {
        utils(
            module.exports
        );
    } else {
        utils(
            RivalIQ.module('utils.facebookInsightsMediaType')
        );
    }

    function utils(exports) {
        const CANONICAL_REEL_VIDEO_MEDIA_TYPE = exports.CANONICAL_REEL_VIDEO_MEDIA_TYPE = 'reel_video';
        const CANONICAL_REEL_VIDEO_DISPLAY_LABEL = exports.CANONICAL_REEL_VIDEO_DISPLAY_LABEL = 'reel/video';
        const CANONICAL_REEL_VIDEO_DISPLAY_VALUE = 'reel/video';
        const LEGACY_REEL_VIDEO_DISPLAY_VALUES = new Set([
            'reels videos',
            'reels/videos'
        ]);

        function normalizeMediaTypeValue(mediaType) {
            return String(mediaType || '').trim().toLowerCase();
        }

        function isCanonicalReelVideoMediaType(mediaType) {
            return normalizeMediaTypeValue(mediaType) === CANONICAL_REEL_VIDEO_MEDIA_TYPE;
        }

        exports.isCanonicalReelVideoMediaType = isCanonicalReelVideoMediaType;

        exports.normalizeMediaTypeForFilter = function (mediaType) {
            return normalizeMediaTypeValue(mediaType);
        };

        exports.getFilterValueFromDisplay = function (mediaType) {
            const normalizedMediaType = normalizeMediaTypeValue(mediaType);

            if (normalizedMediaType === CANONICAL_REEL_VIDEO_DISPLAY_VALUE) {
                return CANONICAL_REEL_VIDEO_MEDIA_TYPE;
            }

            return exports.normalizeMediaTypeForFilter(normalizedMediaType);
        };

        exports.normalizeMediaTypeForDisplay = function (mediaType) {
            const normalizedMediaType = normalizeMediaTypeValue(mediaType);

            if (
                normalizedMediaType === CANONICAL_REEL_VIDEO_DISPLAY_VALUE ||
                LEGACY_REEL_VIDEO_DISPLAY_VALUES.has(normalizedMediaType) ||
                isCanonicalReelVideoMediaType(normalizedMediaType)
            ) {
                return CANONICAL_REEL_VIDEO_DISPLAY_LABEL;
            }

            return mediaType;
        };
    }
}());
